import { useQuery } from "react-query";

import { QUERY_KEYS } from "../../../constants/queryKeys";
import { ReferralApi } from "../../../services";
import type { ReferralCustomerType } from "../../../services/referral/ReferralApi.types";

type UseReferralCustomerOptions = {
  onSuccess?: (data: ReferralCustomerType) => void;
};

export const useReferralCustomer = (
  { uuid, ciam_token }: { uuid: string; ciam_token: string },
  options?: UseReferralCustomerOptions
) => {
  return useQuery(QUERY_KEYS.referralCustomer, () => ReferralApi.init().getCustomer(uuid, ciam_token), {
    enabled: Boolean(uuid && ciam_token),
    onSuccess: options?.onSuccess,
  });
};
